var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConMarkerImageSrcUnselect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0365 33.6068C16.6107 34.1448 16.2544 34.6615 16 35.0516C15.7456 34.6615 15.3893 34.1448 14.9635 33.6068C14.5237 33.0513 14.0026 32.464 13.4362 31.969C12.8751 31.4786 12.2399 31.0525 11.5696 30.8577C5.16748 28.9516 0.5 23.0202 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 23.0202 26.8325 28.9516 20.4303 30.8577C19.7601 31.0525 19.1249 31.4786 18.5638 31.969C17.9974 32.464 17.4763 33.0513 17.0365 33.6068Z",
    fill: "white",
    stroke: "#FF4848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81287 9.06335H20.6879V16.3759C20.6879 18.3434 19.0929 19.9383 17.1254 19.9383H13.3754C11.4079 19.9383 9.81287 18.3434 9.81287 16.3759V9.06335ZM10.9379 10.1884V16.3759C10.9379 17.722 12.0292 18.8134 13.3754 18.8134H17.1254C18.4716 18.8134 19.5629 17.722 19.5629 16.3759V10.1884H10.9379Z",
    fill: "#FF4848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0004 10.1884H20.6879V9.06335H22.0004C22.9323 9.06335 23.6879 9.81887 23.6879 10.7509V13.0009C23.6879 13.9328 22.9323 14.6884 22.0004 14.6884H20.6879V13.5634H22.0004C22.311 13.5634 22.5629 13.3115 22.5629 13.0009V10.7509C22.5629 10.4402 22.311 10.1884 22.0004 10.1884Z",
    fill: "#FF4848"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0004 22.5633H8.50037V21.4383H22.0004V22.5633Z",
    fill: "#FF4848"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConMarkerImageSrcUnselect);
export default __webpack_public_path__ + "static/media/conMarkerImageSrc_unselect.cbe5c13aa7996b2b463aeb5f379ffebd.svg";
export { ForwardRef as ReactComponent };